import { UserNotification } from "../../../redux/user/userSlice";
import axios from "../../privateApi";

export const getUserNotifications = async () => {
  const { data } = await axios.get<UserNotification[]>("/notifications");
  return data;
};
